// extracted by mini-css-extract-plugin
module.exports = {"appModal":"appModal_appModal__3TdSO","cancel":"appModal_cancel__tQ4b8","submit":"appModal_submit__nJI3Q","buttonWrapper":"appModal_buttonWrapper__oER8t"};